import { createStore } from 'redux';
import rootReducer from '../reducers';

const Store = createStore(rootReducer);
export default Store;



// WEBPACK FOOTER //
// ./src/store/index.js